import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class hamstringright extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let hamstringlist= visualisationdetails.hamstringright; 
    
    const data=hamstringlist.map((assmntval) => {  
          return {              
              name: assmntval.assessment,
              hamstringright: assmntval.hamstringright,
              hamstringleft: assmntval.hamstringleft,
              quadright: assmntval.quadright,
              quadleft: assmntval.quadleft
          }
    }); 
    return (
      
      <ResponsiveContainer width={this.props.data} height={400}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
          <YAxis stroke={ChartConfig.axesColor} domain={[0, 'dataMax + 10']} />
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
          <Legend />
          <Bar dataKey="hamstringright" name="Right Hamstring Length" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="hamstringleft" name="Left Hamstring Length" fill={ChartConfig.color.rightshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="quadright" name="Right Quad Muscle Length" fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="quadleft" name="Left Quad Muscle Length" fill={ChartConfig.color.hipgreen} label={{ position: "top" }} barSize={20}/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(hamstringright); 